module.exports = __webpack_public_path__ + "img/volume_mute.30fe0bad.svg";